import { useMutation } from '@tanstack/react-query';
import { useToastContext } from 'context/ToastContext';
import { FirebaseCallable, functions, httpsCallable } from '@util/firebase';
import { ProposedAction } from '@models/approval';

export interface GetNextMessageResponse {
  message: string;
  request_id: string;
  approval_id?: string;
  actions?: ProposedAction[];
  task_id?: string;
  internal?: boolean;
}

export const useSupportBot = ({
  onNextMessage,
}: {
  onNextMessage: (message: string) => void;
}) => {
  const { showErrorToast } = useToastContext();
  const getNextMessageMutation = useMutation({
    mutationFn: async (chat_id: string) => {
      const fn = httpsCallable<{ chat_id: string }, GetNextMessageResponse>(
        functions,
        FirebaseCallable.getNextMessage
      );
      const result = await fn({ chat_id });
      return result.data;
    },
    onError: (error) => {
      showErrorToast(error.message);
    },
  });
  const rewordMessageMutation = useMutation({
    mutationFn: async (message: string) => {
      const fn = httpsCallable<{ message: string }, { message: string }>(
        functions,
        FirebaseCallable.rewordMessage
      );
      const result = await fn({ message });
      return result.data;
    },
    onSuccess: (data) => {
      onNextMessage(data.message);
    },
    onError: (error) => {
      showErrorToast(error.message);
    },
  });
  return { getNextMessageMutation, rewordMessageMutation };
};
